import React from 'react';
import styled from 'styled-components';
import {Input} from 'components/antd';
import {useParams} from 'react-router';
import {useUpdateContentMutation, Content} from 'api';

interface Props {
  content: Content;
}

export default ({content}: Props) => {
  const {id} = useParams<{id: string}>();
  const [updateContent] = useUpdateContentMutation();
  const onChangeTitle = React.useCallback(
    (e: any) =>
      updateContent({variables: {id, attributes: {title: e.target.value}}}),
    [],
  );

  return (
    <Title>
      <Input
        size="large"
        defaultValue={content?.title}
        onBlur={onChangeTitle}
      />
    </Title>
  );
};

const Title = styled.div`
  display: flex;
  align-items: center;

  input {
    font-size: 18px;
    font-weight: bold;
    width: 50%;
    border: none;
    background: transparent;
    flex: 1;
  }

  .ant-input:focus {
    border-color: none !important;
    outline: 0 !important;
    box-shadow: none !important;
  }
`;
